import http from '@/http'

export default {
  namespaced: true,
  actions: {
    async sign(context, { name, email }) {
      const response = await http.post(`document/sign`, {
        name: name,
        email: email,
      })

      return response
    },
  },
}
